var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.88,12.79H6.91v-4.04H2.88v4.04Zm1-3.04h2.04v2.04H3.88v-2.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.88,17.21H6.91v-4.04H2.88v4.04Zm1-3.04h2.04v2.04H3.88v-2.04Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.31,12.78h4.04v-4.04h-4.04v4.04Zm1-3.04h2.04v2.04h-2.04v-2.04Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.31,17.2h4.04v-4.04h-4.04v4.04Zm1-3.04h2.04v2.04h-2.04v-2.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.19,12.22h3.84v-3.23h-3.84v3.23Zm1-2.23h1.84v1.23h-1.84v-1.23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.99,4.06c-1.19,0-2.16,.97-2.16,2.16s.97,2.16,2.16,2.16,2.16-.97,2.16-2.16-.97-2.16-2.16-2.16Zm0,3.82c-.92,0-1.66-.75-1.66-1.66s.75-1.66,1.66-1.66,1.66,.75,1.66,1.66-.75,1.66-1.66,1.66Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.24 5.22 9.62 5.22 9.62 6.75 10.24 6.75 10.95 6.75 10.95 6.14 10.24 6.14 10.24 5.22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.98,6.89l-.96-3.88h-6.71S9.98,.85,9.98,.85l-2.34,2.35h-2.24V1.95c0-.47-.39-.86-.86-.86h-1.48c-.47,0-.86,.39-.86,.86v1.24H.98S.02,7.07,.02,7.07H1v11.64H19.3V6.89h.69ZM3.19,2.09h1.2v1.1h-1.2v-1.1Zm5.72,15.6v-3.53h2.17v3.53h-2.17Zm9.38,.01h-6.21v-3.63c0-.51-.41-.92-.92-.92h-2.33c-.51,0-.92,.41-.92,.92v3.63H2V7.6l2.69-.03L10.01,2.24l5.73,5.33,2.56,.03v10.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent3);
export default __webpack_public_path__ + "static/media/Agent-3.2d8be0462cb68c80d279139713984df6.svg";
export { ForwardRef as ReactComponent };